import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Trash } from "react-bootstrap-icons";
import { Link, useNavigate } from "react-router-dom";
import API from "../../components/API/API";
import BannerUploaderEdit from "../../components/bannerUploaderEdit/bannerUploaderEdit";
import CustomLoader from "../../components/loader/loader";
import SubDomainRouter from "../../components/subDomainRouter/subDomainRouter";
import TokenDetails from "../../components/useUserDetails/useTokenDetails";
import {
  chosenCities,
  chosenCountries,
  industries,
} from "../../constants/extras";
import withRouter from "../../constants/withRouter";
import UploadFile from "../../helper/UploadFile";

const AddEditIntern = (props) => {
  const item_id = props.params.id;

  const NRIStartupsAlias = SubDomainRouter("NRIStartupsAlias");

  const entities = "items";
  const entityType = "NRI-startup";
  const navigate = useNavigate();

  const tokenDetails = TokenDetails();
  const myUserId = tokenDetails?.Email;

  // states
  const [loading, setLoading] = useState(true);
  const [reqLoading, setReqLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});
  // check values
  const [hasValue, setHasValue] = useState(false);
  const [isValid, setIsValid] = useState(false);

  // * ==========================================================================
  const populateList = async (id) => {
    if (!id) {
      setLoading(false);
      return;
    }
    setLoading(true);

    //
    try {
      const response = await API("get", entities + `/${entityType}/` + id);
      setFormData(response?.data);
    } catch (error) {
      console.log(error.response);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    populateList(item_id);
  }, [item_id]);
  // ========================

  const handleFieldChange = (fieldName, fieldValue) => {
    const newState = {
      ...formData,
      [fieldName]: fieldValue,
    };
    setFormData(newState);
  };

  // Checking field values

  const step1Fields = [
    "first_name",
    "last_name",
    "email",
    "phone",
    "country",
    "whatsapp",
    "city",
    "job_title",
    "industry",
  ];
  const step2Fields = [
    "startup_name",
    "founder_name",
    "cofounder_name",
    "website",
    "phase",
    "services",
    "products",
    "proposition",
    "team_size",
    "patents",
    "interest",
    "gst_no",
  ];

  const areFieldsFilled = (fieldNames, formData) => {
    return fieldNames?.every((fieldName) =>
      formData[fieldName] ? formData[fieldName] : ""
    );
  };

  const isStep1FieldsFilled = areFieldsFilled(step1Fields, formData);
  const isStep2FieldsFilled = areFieldsFilled(step2Fields, formData);

  const handleNext = () => {
    const isStep1FieldsFilled = step1Fields.every((field) => formData[field]);

    if (step === 1 && isStep1FieldsFilled) {
      setStep((prevStep) => prevStep + 1);
      setHasValue(false);
      setIsValid(true);
    } else {
      setHasValue(true);
      setIsValid(true);
      window.scrollTo(0, 0);
    }
  };

  const handlePrevious = () => {
    setStep((prevStep) => prevStep - 1);
  };

  // * ==========================================================================
  const handleSubmit = async (event) => {
    if (step === 1 && !isStep2FieldsFilled) {
      setHasValue(true);
      setIsValid(true);
      window.scrollTo(0, 0);
      return;
    }

    setReqLoading(true);

    const reqData = {
      userId: myUserId,
      type: entityType,
      host: window.location.host,
      header: {
        host: window.location.host,
        userId: myUserId,
      },
      data: {
        userId: myUserId,
        ...formData,
      },
    };
    try {
      //
      if (item_id) {
        await API("put", entities + `/${entityType}/` + item_id, reqData);
        navigate(`/${entityType}/items`);
      } else {
        const response = await API("post", entities, reqData);
        navigate(`/share/items_${entityType}/${response.id}/`);
      }
      //
    } catch (error) {
      console.log(error.response);
    } finally {
      setReqLoading(false);
    }
  };
  // * ==========================================================================

  return (
    <>
      {loading ? (
        <CustomLoader />
      ) : (
        <div className="demosAddFormSection demosEditSection">
          {reqLoading ? (
            <>
              <span className="register-loader"> </span>
              <span className="spinnerOverlay"></span>
            </>
          ) : null}

          <Container fluid="lg" className="formMain create my-3">
            <div className="demosAddFormHeader text-center">
              <h2 className="addFormHeading text-capitalize">
                {item_id ? "Edit" : "Add"}&nbsp;
                {NRIStartupsAlias ? NRIStartupsAlias : entityType}
              </h2>
              <div className="demosEditHeader text-center mb-3 mb-lg-5">
                <h5> {item_id ? "Edit" : "Add"} Details Below:</h5>
                <ul className="demosEditList">
                  <li>
                    <button
                      className={
                        step === 1 ? "active stepstriggers" : "stepstriggers"
                      }
                      onClick={() => setStep(1)}
                    >
                      <span>1</span>
                    </button>
                  </li>
                  <li>
                    <button
                      className={
                        step === 2 ? "active stepstriggers" : "stepstriggers"
                      }
                      onClick={() => setStep(2)}
                      disabled={!isStep1FieldsFilled}
                    >
                      <span>2</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            {/*  */}

            <Form
              id="add-demo-form"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <div className="form-section addFormSection event-detail">
                {step === 1 && (
                  <fieldset className="wizard-fieldset demosAddForm position-relative overflow-hidden">
                    <Row className="mx-0 position-relative">
                      <Col md={12} className="position-relative">
                        {formData?.hero_image_url ||
                          formData.hero_image_content ? (
                          <Button
                            className="deleteBtn p-1 btn-danger text-white bg-danger h-auto w-auto position-absolute bottom-0 end-0 mb-5 me-4 z-3"
                            onClick={() => {
                              setFormData({
                                ...formData,
                                hero_image_url: "",
                                hero_image_content: "",
                              });
                            }}
                          >
                            <Trash />
                          </Button>
                        ) : null}
                        <BannerUploaderEdit
                          className="item-hero-img"
                          key={formData?.hero_image_url}
                          label="Big Banner"
                          accept="image/png, image/jpg, image/jpeg"
                          imageType="hero_image"
                          placehold={
                            formData.hero_image_url ||
                            "https://placehold.co/1024x200"
                          }
                          state={formData}
                          setState={(data) => {
                            UploadFile(
                              formData.userId,
                              "hero_image",
                              data?.hero_image_content,
                              data?.hero_image_extension,
                              setReqLoading
                            ).then((url) => {
                              setFormData({
                                ...formData,
                                hero_image_url: url,
                                hero_image_content: "",
                              });
                            });
                          }}
                          imageURL={formData?.hero_image_url}
                          imageContent={formData?.hero_image_content}
                          imageExtension={formData?.hero_image_extension}
                        />
                      </Col>

                      <Col
                        lg={5}
                        md={6}
                        className="list-img-wrap position-relative"
                      >
                        {formData?.listing_image_url ||
                          formData.listing_image_content ? (
                          <Button
                            className="deleteBtn p-1 btn-danger text-white bg-danger h-auto w-auto position-absolute bottom-0 end-0 mb-4 me-4 z-3"
                            onClick={() => {
                              setFormData({
                                ...formData,
                                listing_image_url: "",
                                listing_image_content: "",
                              });
                            }}
                          >
                            <Trash />
                          </Button>
                        ) : null}
                        <BannerUploaderEdit
                          className="item-list-img"
                          key={formData?.listing_image_url}
                          label="Small Banner"
                          accept="image/png, image/jpg, image/jpeg"
                          imageType="listing_image"
                          placehold={
                            formData.listing_image_url ||
                            "https://placehold.co/280x180"
                          }
                          state={formData}
                          setState={(data) => {
                            UploadFile(
                              formData.userId,
                              "listing_image",
                              data?.listing_image_content,
                              data?.listing_image_extension,
                              setReqLoading
                            ).then((url) => {
                              setFormData({
                                ...formData,
                                listing_image_url: url,
                                listing_image_content: "",
                              });
                            });
                          }}
                          imageURL={formData?.listing_image_url}
                          imageContent={formData?.listing_image_content}
                          imageExtension={formData?.listing_image_extension}
                        />
                      </Col>
                    </Row>
                    <Row className="mx-0n align-items-end">
                      <Col md={6}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            type="text"
                            className={`${isValid && hasValue && !formData.first_name
                              ? "border-danger"
                              : ""
                              }`}
                            id="first_name"
                            required
                            value={formData?.first_name}
                            placeholder="name"
                            name="first_name"
                            autoFocus
                            onChange={(e) =>
                              handleFieldChange("first_name", e.target.value)
                            }
                          />
                          <Form.Label
                            className="formLabel"
                            htmlFor="first_name"
                          >
                            First Name
                          </Form.Label>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            type="text"
                            className={`${isValid && hasValue && !formData.last_name
                              ? "border-danger"
                              : ""
                              }`}
                            id="last_name"
                            required
                            value={formData?.last_name}
                            placeholder="name"
                            name="last_name"
                            onChange={(e) =>
                              handleFieldChange("last_name", e.target.value)
                            }
                          />
                          <Form.Label className="formLabel" htmlFor="last_name">
                            Last Name
                          </Form.Label>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            type="email"
                            className={
                              isValid && hasValue && !formData.email
                                ? "border-danger"
                                : ""
                            }
                            id="email"
                            required
                            value={formData?.email}
                            placeholder="email"
                            name="email"
                            onChange={(e) =>
                              handleFieldChange("email", e.target.value)
                            }
                          />
                          <Form.Label className="formLabel" htmlFor="email">
                            Email
                          </Form.Label>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            type="tel"
                            id="whatsapp"
                            value={formData?.whatsapp}
                            placeholder="whatsapp"
                            name="whatsapp"
                            onChange={(e) =>
                              handleFieldChange("whatsapp", e.target.value)
                            }
                          />
                          <Form.Label className="formLabel" htmlFor="whatsapp">
                            Whatsapp
                          </Form.Label>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            type="tel"
                            className={
                              isValid && hasValue && !formData.phone
                                ? "border-danger"
                                : ""
                            }
                            id="phone"
                            required
                            value={formData?.phone}
                            placeholder="phone"
                            name="phone"
                            onChange={(e) =>
                              handleFieldChange("phone", e.target.value)
                            }
                          />
                          <Form.Label className="formLabel" htmlFor="phone">
                            Phone
                          </Form.Label>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Select
                            id="country"
                            className={`form-control text-capitalize ${isValid && hasValue && !formData.country
                              ? "border-danger"
                              : ""
                              }`}
                            required
                            value={formData?.country}
                            name="country"
                            multiple=""
                            onChange={(e) =>
                              handleFieldChange("country", e.target.value)
                            }
                          >
                            <option value="">country</option>
                            {chosenCountries?.map((country) => (
                              <option key={country} value={country}>
                                {country}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Select
                            id="city"
                            className={`form-control text-capitalize ${isValid && hasValue && !formData.city
                              ? "border-danger"
                              : ""
                              }`}
                            required
                            value={formData?.city}
                            name="city"
                            multiple=""
                            onChange={(e) =>
                              handleFieldChange("city", e.target.value)
                            }
                          >
                            <option value="">city</option>
                            {chosenCities?.map((city) => (
                              <option key={city} value={city}>
                                {city}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col md={12} className="pt-3">
                        <h5>Professional Details</h5>
                        <hr />
                      </Col>

                      <Col md={12}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            type="text"
                            className={
                              isValid && hasValue && !formData.job_title
                                ? "border-danger"
                                : ""
                            }
                            id="job_title"
                            required
                            value={formData?.job_title}
                            placeholder="job_title"
                            name="job_title"
                            onChange={(e) =>
                              handleFieldChange("job_title", e.target.value)
                            }
                          />
                          <Form.Label className="formLabel" htmlFor="job_title">
                            Job Title
                          </Form.Label>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Select
                            id="industry"
                            className={`form-control text-capitalize ${isValid && hasValue && !formData.industry
                              ? "border-danger"
                              : ""
                              }`}
                            required
                            value={formData?.industry}
                            name="industry"
                            multiple=""
                            onChange={(e) =>
                              handleFieldChange("industry", e.target.value)
                            }
                          >
                            <option value="">Industry</option>
                            {industries.map((item) => (
                              <option key={item} value={item}>
                                {item}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            type="url"
                            id="linkedin"
                            value={formData?.linkedin}
                            placeholder="linkedin"
                            name="linkedin"
                            onChange={(e) =>
                              handleFieldChange("linkedin", e.target.value)
                            }
                          />
                          <Form.Label className="formLabel" htmlFor="linkedin">
                            LinkedIn
                          </Form.Label>
                        </Form.Group>
                      </Col>

                      <Col md={12} className="mt-3">
                        <Link
                          to={`/${entityType}/items`}
                          className="btn prev demosEditBtn "
                          onClick={handleNext}
                        >
                          Discard
                        </Link>
                        <Button
                          type="button"
                          className="next demosEditBtn "
                          onClick={handleNext}
                        >
                          Next
                        </Button>
                      </Col>
                    </Row>
                  </fieldset>
                )}

                {step === 2 && (
                  <fieldset className="wizard-fieldset demosAddForm">
                    <Row className="mx-0">
                      <Col md={12}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            type="text"
                            className={
                              isValid && hasValue && !formData.startup_name
                                ? "border-danger"
                                : ""
                            }
                            id="startup_name"
                            required
                            value={formData?.startup_name}
                            placeholder="startup_name"
                            name="startup_name"
                            onChange={(e) =>
                              handleFieldChange("startup_name", e.target.value)
                            }
                          />
                          <Form.Label
                            className="formLabel"
                            htmlFor="startup_name"
                          >
                            startup name
                          </Form.Label>
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            type="text"
                            className={
                              isValid && hasValue && !formData.founder_name
                                ? "border-danger"
                                : ""
                            }
                            id="founder_name"
                            required
                            value={formData?.founder_name}
                            placeholder="founder_name"
                            name="founder_name"
                            onChange={(e) =>
                              handleFieldChange("founder_name", e.target.value)
                            }
                          />
                          <Form.Label
                            className="formLabel"
                            htmlFor="founder_name"
                          >
                            founder's name
                          </Form.Label>
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            type="text"
                            className={
                              isValid && hasValue && !formData.cofounder_name
                                ? "border-danger"
                                : ""
                            }
                            id="cofounder_name"
                            required
                            value={formData?.cofounder_name}
                            placeholder="cofounder_name"
                            name="cofounder_name"
                            onChange={(e) =>
                              handleFieldChange(
                                "cofounder_name",
                                e.target.value
                              )
                            }
                          />
                          <Form.Label
                            className="formLabel"
                            htmlFor="cofounder_name"
                          >
                            cofounder's name
                          </Form.Label>
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            type="url"
                            className={
                              isValid && hasValue && !formData.website
                                ? "border-danger"
                                : ""
                            }
                            id="website"
                            required
                            value={formData?.website}
                            placeholder="website"
                            name="website"
                            onChange={(e) =>
                              handleFieldChange("website", e.target.value)
                            }
                          />
                          <Form.Label className="formLabel" htmlFor="website">
                            Website
                          </Form.Label>
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Select
                            type="text"
                            id="phase"
                            className={`form-control text-capitalize ${isValid && hasValue && !formData.phase
                              ? "border-danger"
                              : ""
                              }`}
                            required
                            value={formData?.phase}
                            placeholder="phase"
                            name="phase"
                            onChange={(e) =>
                              handleFieldChange("phase", e.target.value)
                            }
                          >
                            <option value={""}>Startup Phase</option>
                            <option value={"idea phase"}>idea phase</option>
                            <option value={"seed & development phase"}>
                              seed & development phase
                            </option>
                            <option value={"growth phase"}>growth phase</option>
                            <option value={"established phase"}>
                              established phase
                            </option>
                            <option value={"expansion phase"}>
                              expansion phase
                            </option>
                            <option value={"maturity & possible exit phase"}>
                              maturity & possible exit phase
                            </option>
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            as={"textarea"}
                            rows={4}
                            id="bio"
                            value={formData?.bio}
                            placeholder="bio"
                            name="bio"
                            autoFocus
                            onChange={(e) =>
                              handleFieldChange("bio", e.target.value)
                            }
                          />
                          <Form.Label
                            className="formLabel text-capitalize"
                            htmlFor="bio"
                          >
                            Startup Bio
                          </Form.Label>
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            type="text"
                            className={
                              isValid &&
                                hasValue &&
                                !formData.registered_location
                                ? "border-danger"
                                : ""
                            }
                            id="registered_location"
                            required
                            value={formData?.registered_location}
                            placeholder="registered_location"
                            name="registered_location"
                            onChange={(e) =>
                              handleFieldChange(
                                "registered_location",
                                e.target.value
                              )
                            }
                          />
                          <Form.Label
                            className="formLabel"
                            htmlFor="registered_location"
                          >
                            In which country have you registered/planning to
                            register your Startup?
                          </Form.Label>
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            type="text"
                            className={
                              isValid && hasValue && !formData.products
                                ? "border-danger"
                                : ""
                            }
                            id="products"
                            required
                            value={formData?.products}
                            placeholder="products"
                            name="products"
                            onChange={(e) =>
                              handleFieldChange("products", e.target.value)
                            }
                          />
                          <Form.Label className="formLabel" htmlFor="products">
                            product(s) offered
                          </Form.Label>
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            type="text"
                            className={
                              isValid && hasValue && !formData.services
                                ? "border-danger"
                                : ""
                            }
                            id="services"
                            required
                            value={formData?.services}
                            placeholder="services"
                            name="services"
                            onChange={(e) =>
                              handleFieldChange("services", e.target.value)
                            }
                          />
                          <Form.Label className="formLabel" htmlFor="services">
                            service(s) offered
                          </Form.Label>
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            as={"textarea"}
                            rows={4}
                            id="proposition"
                            value={formData?.proposition}
                            placeholder="proposition"
                            name="proposition"
                            autoFocus
                            onChange={(e) =>
                              handleFieldChange("proposition", e.target.value)
                            }
                          />
                          <Form.Label
                            className="formLabel text-capitalize"
                            htmlFor="proposition"
                          >
                            Value Proposition (Explain how your product solves
                            customer problems or improves their situation)
                          </Form.Label>
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            type="text"
                            className={
                              isValid && hasValue && !formData.team_size
                                ? "border-danger"
                                : ""
                            }
                            id="team_size"
                            required
                            value={formData?.team_size}
                            placeholder="team_size"
                            name="team_size"
                            onChange={(e) =>
                              handleFieldChange("team_size", e.target.value)
                            }
                          />
                          <Form.Label className="formLabel" htmlFor="team_size">
                            Current Team Size
                          </Form.Label>
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            type="text"
                            className={
                              isValid && hasValue && !formData.patents
                                ? "border-danger"
                                : ""
                            }
                            id="patents"
                            required
                            value={formData?.patents}
                            placeholder="patents"
                            name="patents"
                            onChange={(e) =>
                              handleFieldChange("patents", e.target.value)
                            }
                          />
                          <Form.Label className="formLabel" htmlFor="patents">
                            Do you have any patent(s)? Name them.
                          </Form.Label>
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Select
                            type="text"
                            id="interest"
                            className={`form-control text-capitalize ${isValid && hasValue && !formData.interest
                              ? "border-danger"
                              : ""
                              }`}
                            required
                            value={formData?.interest}
                            placeholder="interest"
                            name="interest"
                            onChange={(e) =>
                              handleFieldChange("interest", e.target.value)
                            }
                          >
                            <option value={""}>Select your interest(s)</option>
                            <option value={"mentoring"}>mentoring</option>
                            <option value={"startup funding"}>
                              startup funding
                            </option>
                            <option value={"virtual CXO"}>virtual CXO</option>
                            <option value={"finding a Co-Founder"}>
                              finding a Co-Founder
                            </option>
                            <option value={"IT development support"}>
                              IT development support
                            </option>
                            <option value={"virtual accentor support"}>
                              virtual accentor support
                            </option>
                            <option value={"other"}>other</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            as={"textarea"}
                            rows={4}
                            id="achievement"
                            value={formData?.achievement}
                            placeholder="achievement"
                            name="achievement"
                            autoFocus
                            onChange={(e) =>
                              handleFieldChange("achievement", e.target.value)
                            }
                          />
                          <Form.Label
                            className="formLabel text-capitalize"
                            htmlFor="achievement"
                          >
                            Major Achievements
                          </Form.Label>
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <small className="text-end d-block text-dark">
                          required<span className="text-danger">*</span>
                        </small>
                        <Form.Group className="form-floating mb-3">
                          <Form.Control
                            type="text"
                            className={
                              isValid && hasValue && !formData.gst_no
                                ? "border-danger"
                                : ""
                            }
                            id="gst_no"
                            required
                            value={formData?.gst_no}
                            placeholder="gst_no"
                            name="gst_no"
                            onChange={(e) =>
                              handleFieldChange("gst_no", e.target.value)
                            }
                          />
                          <Form.Label className="formLabel" htmlFor="gst_no">
                            Is your startup registered? If yes, provide GST
                            number
                          </Form.Label>
                        </Form.Group>
                      </Col>

                      <Col md={12} className="mt-3">
                        <Button
                          type="button"
                          className="previous-button demosEditBtn"
                          onClick={handlePrevious}
                        >
                          Previous
                        </Button>
                        <Button type="submit" className="next demosEditBtn">
                          Submit
                        </Button>
                      </Col>
                    </Row>
                  </fieldset>
                )}
              </div>
            </Form>
          </Container>
        </div>
      )}
    </>
  );
};

export default withRouter(AddEditIntern);
